import { useEffect, useState } from "react";
import {
	readSidebarState,
	writeSidebarField,
	type SidebarState,
} from "../common/utils/sidebar_storage";

type FlagField = {
	[K in keyof SidebarState]: SidebarState[K] extends boolean ? K : never;
}[keyof SidebarState];

/** One collapsible section of the sidebar, remembered across visits. Reading and
 *  writing go through the shared sidebar key, which falls back per field rather than
 *  taking the render down when the store holds something unexpected or refuses to be
 *  read at all. */
export const useSidebarFlag = (field: FlagField) => {
	const [value, setValue] = useState(() => readSidebarState()[field]);

	useEffect(() => {
		writeSidebarField(field, value);
	}, [field, value]);

	return [value, setValue] as const;
};
